// Close sibling accordion rows when one opens — one open at a time per accordion.
// Footer menu columns are excluded: each is independently "always open" on
// desktop, so they must not be forced mutually exclusive.
document.addEventListener('toggle', (event) => {
  const details = event.target;
  if (!(details instanceof HTMLDetailsElement) || !details.open) return;
  if (details.closest('footer')) return;

  const accordion = details.closest('.accordion');
  if (accordion) {
    accordion.querySelectorAll('details').forEach((s) => { if (s !== details) s.open = false; });
    return;
  }

  const menuAccordion = details.closest('.menu--accordion');
  if (menuAccordion) {
    menuAccordion.parentElement?.querySelectorAll('.menu--accordion details').forEach((s) => {
      if (s !== details) s.open = false;
    });
  }
}, true);
